import React from "react";
import { Slide } from "react-reveal";
import ClientCard from "../reusables/ClientCard";

const Clientelle = () => {
  return (
    <section className="section section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="width-600 center margin-auto">
              <p className="section-name boldTitle dark">CLIENTS</p>
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title green">OUR CLIENTELLE</h2>
                </div>
              </Slide>
            </div>
            <div className="section-body width-800 margin-auto">
              <ul className="clients-container section-spacing-20">
                <ClientCard client="DAN General Trading Co. Ltd" />
                <ClientCard client="Star Distillers Co. Ltd" />
                <ClientCard client="Plankton General Trading" />
                <ClientCard client="Gok machar" />
                <ClientCard client="Bank Of South Sudan(BOSS)" />
                <ClientCard client="Juba Grand Hotel" />
                <ClientCard client="CONCORD HOTEL CO. LTD" />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clientelle;
